import { atom } from 'jotai';
import type { ChartImageExporter } from 'components/chart-export';
import {
  closeExportImageAtom,
  exportImageStateAtom,
} from 'components/chart-export/atoms';

/**
 * The user's factor-group order for Step 3 (group keys). `null` means "use the default
 * order"; it's set once the user reorders. A simple in-memory atom — the flow's only
 * genuine client state (the eval pair lives in the URL, the analysis in React Query) —
 * so the order persists across the flow's client-side navigation but resets on a full
 * page reload. An atom (not page-local `useState`) precisely because the Step-3 page
 * unmounts on navigation, and the order must survive that. `reconcileFactorGroupOrder`
 * guards a stale order (e.g. one carried across pairs), so it needs no per-pair reset.
 */
export const factorGroupOrderAtom = atom<string[] | null>(null);

/**
 * Closes the app-wide Export Image drawer, but only while it's open for `exporter` — so a chart
 * whose export went stale (unmounted, torn down, or retitled) never closes a drawer another chart
 * opened.
 */
export const closeExportImageForAtom = atom(
  null,
  (get, set, exporter: ChartImageExporter) => {
    if (get(exportImageStateAtom).exporter === exporter) {
      set(closeExportImageAtom);
    }
  }
);
